/**
 * @generated SignedSource<<daced8c1ad2f8ae40164f5ea25745d36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogLayout_viewer$data = {
  readonly catalogPage: {
    readonly images: {
      readonly pageCount: number | null;
    } | null;
    readonly serviceId: string | null;
    readonly socialShareURLWithFallback: string | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CatalogDocument_catalogPage" | "CatalogMenuBar_catalogPage">;
  } | null;
  readonly user?: {
    readonly profile: {
      readonly email: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Error404Layout_viewer">;
  readonly " $fragmentType": "CatalogLayout_viewer";
};
export type CatalogLayout_viewer$key = {
  readonly " $data"?: CatalogLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "pageTypeId"
    },
    {
      "kind": "RootArgument",
      "name": "rootId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Error404Layout_viewer"
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "rootId"
        },
        {
          "kind": "Variable",
          "name": "pageTypeId",
          "variableName": "pageTypeId"
        }
      ],
      "concreteType": "CatalogPage",
      "kind": "LinkedField",
      "name": "catalogPage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialShareURLWithFallback",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CatalogImagesType",
          "kind": "LinkedField",
          "name": "images",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pageCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CatalogDocument_catalogPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CatalogMenuBar_catalogPage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c47ec8feee7859799c6ce8c89872dc48";

export default node;
